import { Component, OnInit } from '@angular/core';
import { AclService, EAccessName } from 'src/app/libs/services/acl.service';
import { ESlideMenuOptions } from 'src/app/services/config.service';

@Component({
    selector: 'app-products-configuration',
    templateUrl: './products-configuration.component.html',
    styleUrls: ['./products-configuration.component.sass'],
    standalone: false
})
export class ProductsConfigurationComponent implements OnInit {
  items: ESlideMenuOptions[] = [];

  constructor(private permissions:AclService) {}

  ngOnInit(): void {
    this.items = [];

    this.items.push(ESlideMenuOptions.Mch_Formats);
    this.items.push(ESlideMenuOptions.Mch_ProductBatchStates);
    this.items.push(ESlideMenuOptions.Mch_BatchTypes);

    if (this.hasPermissions(EAccessName.EquipmentsConfiguration)) {
      this.items.push(ESlideMenuOptions.Mch_TechnicalFeatures);
      this.items.push(ESlideMenuOptions.Mch_TechnicalFeatureGroups);
    }
  }

  hasPermissions = (permission:string):boolean => this.permissions.isAllowed(permission as EAccessName);
}
